<template>
  <section class="content">
    <div class="row center-block">
      <div
        v-if="getRoleType === 99"
        class="col-xs-12 p-x-0 m-b-10 flex align-center"
      >
        <div class="flex grey darken-1">
          <div
            v-if="brand.name || store.brand_name"
            class="m-r-5"
            v-text="brand.name ? brand.name : store.brand_name ? store.brand_name : ''"
          />
          <div
            v-if="store.name"
            class="m-r-5"
            v-text="'/'"
          />
          <div
            v-if="store.name"
            v-text="store.name"
          />
        </div>
      </div>
      <div class="col-md-12">
        <cr-join-menu />
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import crJoinMenuTemp from './Temp/CrJoinMenuTemp.vue'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

export default {
  name: 'UpJoinMenu',
  extends: NdExtendHandleMenu,
  components: {
    'cr-join-menu': crJoinMenuTemp
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    checkInput () {
      return this.$parent.checkInput
    }
  },
  mounted () {
    this.getExtendHandleMenuInfo()
  }
}
</script>



// WEBPACK FOOTER //
// UpJoinMenu.vue?07c3fa91